/**
 * SectionLabel — narrative anchor for major story chapters.
 * Use sparingly: only on sections with genuine narrative value.
 *
 *   <SectionLabel index="01" text="Konzept" />
 */
export default function SectionLabel({ index, text, inverse = false, className = "" }) {
  return (
    <div
      className={`section-label ${inverse ? "section-label--inverse" : ""} ${className}`}
      data-testid={`section-label-${index}`}
    >
      <span className="section-label-num">{index}</span>
      <span className="section-label-rule" aria-hidden="true" />
      <span className="section-label-text">{text}</span>
    </div>
  );
}
